import cloneDeep from 'lodash/cloneDeep';

import {
  SET_ACTIVE_BOT_USER,
  SET_ACTIVE_BOT_USER_SCHEMA,
  GET_BLOCKED_BOT_USERS_SUCCESS, BLOCKED_BOT_USERS_UPDATE,
} from "../actions/Audience";
import unionBy from "lodash/unionBy";
import filter from "lodash/filter";


const defaultState = {
  activeBotUser: undefined,
  activeBotUserSchema: undefined,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_ACTIVE_BOT_USER:
      return {
        ...state,
        activeBotUser: cloneDeep(action.botUser),
      };

    case SET_ACTIVE_BOT_USER_SCHEMA:
      return {
        ...state,
        activeBotUserSchema: cloneDeep(action.schema),
      };
    case GET_BLOCKED_BOT_USERS_SUCCESS:
      return {
        ...state,
        blockedBotUsersList: action.result
      };
    case BLOCKED_BOT_USERS_UPDATE:
      let newBlockedUsers;
      console.error('action', action)
      console.error('action.isDelete', action.isDelete)
      if (!action.isDelete) {
        newBlockedUsers = unionBy(state.blockedBotUsersList, [action.update], (data) => data.bot_user_id);
      } else {
        console.error('action.delete')
        newBlockedUsers = filter(state.blockedBotUsersList, (data) => data.bot_user_id !== action.update.bot_user_id);
      }
      console.error('newBlockedUsers.', newBlockedUsers)
      return {
        ...state,
        blockedBotUsersList: newBlockedUsers
      };
  }
  return state;
}
